import React from 'react';
import { INextQUestionProps } from 'views/pages/survey/surveyAdd/ContentAdd/components/ModalChildAddingQuestions';
import {
  DdlDepartment,
  ICreateOneAndManyAnswer,
  ICreateQuestionMatrix,
  ICreateQuestionMatrixList,
  ICreateQuestionNoAnswer,
  ICreateQuestionRating,
  IQuestionValuesForm,
  IDetailQuestionBank,
} from '../type';
import { Range } from 'utils/helperFunctions';

export type TSelectType =
  | 'oneAnswer'
  | 'manyAnswer'
  | 'text'
  | 'number'
  | 'matrix'
  | 'matrixFromList'
  | 'chooseDate'
  | 'choseHour'
  | 'lineUp'
  | 'evaluated'
  | 'oneAnswer360branch';

export const SelectType: { [key in TSelectType]: TSelectType } = {
  oneAnswer: 'oneAnswer',
  manyAnswer: 'manyAnswer',
  text: 'text',
  number: 'number',
  matrix: 'matrix',
  matrixFromList: 'matrixFromList',
  chooseDate: 'chooseDate',
  choseHour: 'choseHour',
  lineUp: 'lineUp',
  evaluated: 'evaluated',
  oneAnswer360branch: 'oneAnswer360branch',
};

export const mappingSelectType = {
  text: '1',
  oneAnswer: '2',
  manyAnswer: '3',
  number: '4',
  matrix: '5',
  matrixFromList: '6',
  chooseDate: '7',
  choseHour: '8',
  lineUp: '9',
  evaluated: '10',
  oneAnswer360branch: '11',
} as Record<string, any>;

export type TIconTypeRating = 'WOW' | 'KPI' | 'STAR' | 'NUMBER' | 'EX_1' | 'EX_2' | 'EX_3';
export type TMaxLevelRating = 4 | 5 | 6 | 10;

export const iconTypeRatingQuestion: Record<TIconTypeRating, Range<1, 8>> = {
  WOW: 1,
  KPI: 2,
  STAR: 3,
  NUMBER: 4,
  EX_1: 5,
  EX_2: 6,
  EX_3: 7,
};

export const maxLevelRatingQuestion: Record<TIconTypeRating, TMaxLevelRating> = {
  WOW: 5,
  KPI: 4,
  STAR: 10,
  NUMBER: 10,
  EX_1: 6,
  EX_2: 6,
  EX_3: 6,
};

export const minLevelRatingQuestion: Record<TIconTypeRating, number> = {
  WOW: 1,
  KPI: 1,
  STAR: 1,
  NUMBER: 1,
  EX_1: 1,
  EX_2: 1,
  EX_3: 1,
};

//****************************************************************** */

export type CombineTypeAnswer =
  | ICreateOneAndManyAnswer
  | ICreateQuestionNoAnswer
  | ICreateQuestionMatrix
  | ICreateQuestionMatrixList
  | ICreateQuestionRating;

interface IFiledInputCompletedForm {
  isCompleted: boolean;
  message: string;
}

export interface ICompleteFieldForm {
  orderQuestion: IFiledInputCompletedForm;
}

export interface IQuestionAddProps {
  selectType: TSelectType;
  handleBack: () => void;
  questionGroupID?: string;
  departments?: DdlDepartment[];
  setDepartments?: React.Dispatch<React.SetStateAction<DdlDepartment[]>>;
  setQuestionGroupID?: React.Dispatch<React.SetStateAction<string>>;

  setIsDepartmentValid?: React.Dispatch<React.SetStateAction<boolean>>;
  setSubmitForm?: React.Dispatch<React.SetStateAction<boolean>>;
  disabledQuestionIsUsed?: boolean; //case for update question is used in survey
  setIsQuestionUsed?: React.Dispatch<React.SetStateAction<boolean>>;
  oldFormikValues?: IQuestionValuesForm;
  setOldFormikValue?: React.Dispatch<React.SetStateAction<IQuestionValuesForm>>;
  questionDataInfo?: IDetailQuestionBank; //question data when edit question in question bank
  questionIDInQuestionBank?: string; // case in question-add UI when update question not create question
  setQuestionIDInQuestionBank?: (question: React.SetStateAction<string>) => void;
  /**
   * Props for survey list
   */
  isInSurvery?: boolean;
  handleSave?: (
    answer: CombineTypeAnswer,
    callback?: () => void,
    callApiUpdateQuestion?: () => void,
    currentQuestionOrder?: string
  ) => void;
  openModalConfirm?: boolean;
  handleClose?: () => void;
  nextQuestionProp?: string;
  nextQuestionComponent?: ({ isDisabled }: INextQUestionProps) => JSX.Element;
  selectQuestionID?: string;
  // user is evaluated 360
  questionTypeID?: string;
  surveyID?: string | null;
  questions?: any;
  isAddEvaluated?: boolean;
  questionID?: string;
  surveyStatus?: number;
  setIsQuestionExistInOtherSurvey?: React.Dispatch<React.SetStateAction<boolean>>;
  copySurvey?: boolean;
  questionIDArrCopy?: string[];
  setNextQuestion?: React.Dispatch<React.SetStateAction<string>>;
  questionOrder?: string;
  isLoadingModal: boolean; //if parent component is loading for call api...
  setDefaultDepartments?: React.Dispatch<React.SetStateAction<DdlDepartment[]>>;
  ddlDepartmentSurvey?: DdlDepartment[]; //list department when add/edit question in survey
}
export interface IcheckImgInDatabase {
  isExistImg: boolean;
  isExistUrl: string;
}
